// src/components/StickyCart.jsx
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
import { triggerHaptic } from '../utils/haptics';

const StickyCart = ({ totalAmount, totalCount, onClick }) => {
  return (
    <AnimatePresence>
      {totalCount > 0 && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          // CHANGED: bottom-4 -> bottom-[90px] (чтобы висеть над навигацией)
          className="fixed bottom-[90px] left-4 right-4 z-50"
        >
          <button
            onClick={() => {
              onClick();
              triggerHaptic('medium');
            }}
            className="w-full bg-tg-button text-white py-3.5 px-5 rounded-2xl shadow-lg shadow-tg-button/30 flex items-center justify-between font-medium active:scale-95 transition-transform"
          >
            <div className="flex items-center gap-2">
              <div className="bg-white/20 p-1.5 rounded-lg">
                <ShoppingBag size={20} className="text-white" />
              </div>
              <span className="text-sm opacity-90 text-white font-semibold">{totalCount} товар</span>
            </div>
            
            <div className="flex items-center gap-2 text-white">
              <span>Оформить</span>
              <span className="bg-white text-tg-button px-2 py-0.5 rounded-md text-sm font-bold shadow-sm">
                {totalAmount} ₽
              </span>
            </div>
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyCart;
